import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=ffa94f8a"
import script from "./FormBlock.vue?vue&type=script&lang=ts"
export * from "./FormBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports